// extracted by mini-css-extract-plugin
export var deliveryRow = "_q6-a";
export var fixedHeight = "_q6-4";
export var freightLogo = "_q6-9";
export var fullWidth = "_q6-3";
export var priceColumn = "_q6-5";
export var radioSelected = "_q6-7";
export var radioUnselected = "_q6-6";
export var selectedOption = "_q6-2";
export var selectedOptionContainer = "_q6-1";
export var selection = "_q6-0";
export var tallSkeletonText = "_q6-8";